<template>
  <header class="topbar overlayed">
    <div class="img">
      <router-link to="/">
        <img class="img__left" src="@/assets/images/logo_efest.png" alt="">
      </router-link>
    </div>
    <div class="img">
      <img class="img__right" src="@/assets/images/logo_tema.png" alt="">
    </div>
    <div id="burger"
      class="responsive-mobile"
      :class="{ 'active' : isOpen }"
      @click.prevent="toggle">
      <slot>
        <button type="button" class="burger-button" title="Menu">
          <span class="burger-bar burger-bar--1"></span>
          <span class="burger-bar burger-bar--2"></span>
          <span class="burger-bar burger-bar--3"></span>
        </button>
      </slot>
    </div>
    <div id="sidebar" class="sidebar responsive-mobile">
      <transition name="slide">
        <div class="sidebar-panel margin-md-20">
          <ul class="list">
              <li class="list__item animate"  @click="toggle()">
                <router-link class="display-block" to="/kiko-run">
                  Kiko Run Competition
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/parade-live">
                  Live Shopping Parade
                </router-link>
              </li>
              <li  class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/digital-career">
                  MNC Digital Career Fest
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/tech-forum">  
                  MNC Tech Forum
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/motion-tech">
                  MotionTech Launch
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/nyapit-cuan">
                  Nyapit Cuan #2
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/virtual-hangout"> 
                  Virtual Hangout & Video Challange by Klaklik
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/content-creator">
                  Content Creator Performances by MNC Stars
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/visions-plus">
                  Watch & Win - Vision+ Original Series
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/rcti-plus"> 
                  RCTI+ Special Programs
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/csr-mnc"> 
                  CSR For Covid-19
                </router-link>
              </li>
              <li class="list__item animate" @click="toggle()">
                <router-link class="display-block" to="/onair-concert"> 
                  On Air Concert - Anniversary Celebration
                </router-link>
              </li>
          <div>
            <a target="_blank" href="https://www.instagram.com/mncfest2021/">
              <img class="logo_ig" src="@/assets/images/ig.png" alt="">
            </a>
          </div>
          </ul>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default {
  name: 'Topbar',
  data() {
    return {
      isOpen: false,
    }
  },
  mounted() {
    this.sideAnimation();
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen

      const sidebar = document.querySelector("#sidebar")

      if(sidebar.classList.contains('active-sidebar')) {
        sidebar.classList.remove('active-sidebar')
      } else {
        sidebar.classList.add('active-sidebar')
        this.sideAnimation()
      }
    },
    sideAnimation() {
      const tl = gsap.timeline()

      tl.fromTo('.animate', 
      {x:-100 , opacity: 0},
      {stagger:0.2 , duration: .5 , x: 0 , opacity: 1}
      )
}
  }
}
</script>